import { Component } from '@angular/core';

@Component({
  selector: 'app-tous-cmd-fourn',
  templateUrl: './tous-cmd-fourn.component.html',
  styleUrls: ['./tous-cmd-fourn.component.scss']
})
export class TousCmdFournComponent {}
